import { render } from "./EditProfileEducation.vue?vue&type=template&id=d73a593c"
import script from "./EditProfileEducation.vue?vue&type=script&lang=js"
export * from "./EditProfileEducation.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__